@if (loading$ | async) {
  <ng-template #loader>
    <div class="mt-8 w-full max-w-sm rounded-md border border-blue-200 p-4 shadow">
      <div class="flex animate-pulse space-x-4">
        <div class="flex-1 space-y-4 py-1">
          <div class="flex justify-between">
            <div class="h-4 w-1/6 rounded bg-blue-200"></div>
            <div class="grow"></div>
            <div class="h-4 w-1/6 rounded bg-blue-200"></div>
            <div class="ml-2 h-4 w-1/6 rounded bg-blue-200"></div>
          </div>
          <div class="space-y-2">
            <div class="h-3 w-3/6 rounded bg-blue-200"></div>
            <div class="h-3 w-2/6 rounded bg-blue-200"></div>
            <div class="h-3 w-4/6 rounded bg-blue-200"></div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-container [ngTemplateOutlet]="loader" />
  <ng-container [ngTemplateOutlet]="loader" />
}
@if ((loading$ | async) === false) {
  <div class="flex items-center justify-between">
    <aux-input
      class="w-72"
      placeholder="Search"
      icon="Search"
      iconPosition="left"
      hotKey="/"
      [(ngModel)]="filterValue"
      (change)="filterChanges()"
      (keyup)="updateSearch($event.target)"
    />

    <div class="space-x-[10px]">
      <aux-button
        [disabled]="!copyUserPermission()"
        [auxTooltip]="copyUserPermissionDisabledTooltip()"
        label="Copy Users"
        icon="Copy"
        variant="secondary"
        [spinnerSize]="7"
        (click)="showCopyUsersModal()"
      />
      <aux-button
        [disabled]="!userHasUpdateUserPermission"
        [auxTooltip]="noPermissionsTooltipText()"
        label="Add New User"
        icon="Plus"
        variant="primary"
        (click)="onAddUser()"
      />
    </div>
  </div>

  @for (userGroup of users$ | async | groupBy: 'organization.name'; track userGroup) {
    <div class="mb-2 mt-4 border-b">
      {{ userGroup.key }}
    </div>

    <div class="mt-4 flex flex-wrap">
      @for (user of userGroup.value; track user) {
        <div class="mr-4 mt-4 flex w-64 flex-col justify-between rounded-md border p-4">
          <div class="mb-2 flex justify-between">
            <div
              class="rounded-md px-1 py-0.5 text-xxs font-medium"
              [ngClass]="{
                'bg-aux-green text-white': user.role === 'ROLE_ADMIN',
                'bg-aux-gray-dark': user.role === 'ROLE_USER',
              }"
            >
              {{ user.role === 'ROLE_ADMIN' ? 'Admin' : 'User' }}
            </div>
          </div>

          <div class="break-words text-sm">
            <div class="font-bold">{{ user.given_name }} {{ user.family_name }}</div>
            <div>
              {{ user.title ? user.title + ',' : '' }} {{ getDepartmentString(user.department) }}
            </div>
            <a href="#" class="font-medium">{{ user.email }}</a>
            @if (!user.last_login_date) {
              <div class="item-center flex">
                <span class="mr-1 italic">Pending</span>
                <div>(</div>
                <aux-button
                  variant="hyperlink"
                  [auxTooltip]="noPermissionsTooltipText()"
                  [disabled]="!userHasUpdateUserPermission"
                  (clickEmit)="resendInvitation(user)"
                  label="Resend invite"
                  classList="leading-5 p-0"
                />
                <div>)</div>
              </div>
            }
            @if (flags().showUserLastLogin) {
              <div>
                @if (user.last_login_date) {
                  <div>
                    {{ user.last_login_date | date: 'MM/dd/YYYY HH:mm a' }}
                  </div>
                }
              </div>
            }
          </div>

          <div class="mt-4 flex items-center space-x-2 text-sm font-medium">
            <aux-button
              classList="btn px-2 h-8"
              [ngClass]="{
                'opacity-50': !userHasUpdateUserPermission,
              }"
              [disabled]="!userHasUpdateUserPermission"
              [auxTooltip]="noPermissionsTooltipText()"
              icon="Pencil"
              svgAttributes="text-aux-blue"
              variant="custom"
              (click)="onEditUser(user)"
            />

            <aux-button
              classList="btn px-2 h-8"
              [ngClass]="{
                'opacity-50': !userHasUpdateUserPermission,
              }"
              [disabled]="!userHasUpdateUserPermission"
              [auxTooltip]="noPermissionsTooltipText()"
              icon="Trash"
              svgAttributes="text-aux-error"
              variant="custom"
              (click)="onRemoveUser(user)"
            />
          </div>
        </div>
      }
    </div>
  }

  @if ((auxUsers$ | async)?.length) {
    <div>
      <div class="mb-2 mt-4 border-b">
        Auxilius Support
        <button type="button" class="align-top" (click)="toggleAuxSupport()">
          @if (!showAuxSupport) {
            <aux-icon name="ChevronDown" />
          }
          @if (showAuxSupport) {
            <aux-icon name="ChevronUp" />
          }
        </button>
      </div>
      @if (showAuxSupport) {
        <div>
          <div class="mt-4 flex flex-wrap">
            @for (user of auxUsers$ | async; track user) {
              <div class="mr-4 mt-4 flex w-64 flex-col justify-between rounded-md border p-4">
                <div class="mb-2 flex justify-between">
                  <div
                    class="rounded-md px-1 py-0.5 text-xxs font-medium"
                    [ngClass]="{
                      'bg-aux-green text-white': user.role === 'ROLE_ADMIN',
                      'bg-aux-gray-dark': user.role === 'ROLE_USER',
                    }"
                  >
                    {{ user.role === 'ROLE_ADMIN' ? 'Admin' : 'User' }}
                  </div>
                </div>

                <div class="break-words text-sm">
                  <div class="font-bold">{{ user.given_name }} {{ user.family_name }}</div>
                  <div>
                    {{ user.title }}{{ user.title ? ', ' : ''
                    }}{{ getDepartmentString(user.department) }}
                    Auxilius Support
                  </div>
                  <a href="#" class="font-medium">{{ user.email }}</a>
                  @if (!user.last_login_date) {
                    <div class="item-center flex">
                      <span class="mr-1 italic">Pending</span>
                      <div>(</div>
                      <aux-button
                        variant="hyperlink"
                        [auxTooltip]="noPermissionsTooltipText()"
                        [disabled]="!userHasUpdateUserPermission"
                        (clickEmit)="resendInvitation(user)"
                        label="Resend invite"
                        classList="leading-5 p-0"
                      />
                      <div>)</div>
                    </div>
                  }
                  @if (flags().showUserLastLogin) {
                    <div>
                      @if (user.last_login_date) {
                        <div>
                          {{ user.last_login_date | date: 'MM/dd/YYYY HH:mm a' }}
                        </div>
                      }
                    </div>
                  }
                </div>

                <div class="mt-4 flex items-center space-x-2 text-sm font-medium">
                  <aux-button
                    classList="btn px-2 h-8"
                    [ngClass]="{
                      'opacity-50': !userHasUpdateUserPermission,
                    }"
                    [disabled]="!userHasUpdateUserPermission"
                    [auxTooltip]="noPermissionsTooltipText()"
                    icon="Pencil"
                    svgAttributes="text-aux-blue"
                    variant="custom"
                    (click)="onEditUser(user)"
                  />

                  <aux-button
                    classList="btn px-2 h-8"
                    [ngClass]="{
                      'opacity-50': !userHasUpdateUserPermission,
                    }"
                    [disabled]="!userHasUpdateUserPermission"
                    [auxTooltip]="noPermissionsTooltipText()"
                    icon="Trash"
                    svgAttributes="text-aux-error"
                    variant="custom"
                    (click)="onRemoveUser(user)"
                  />
                </div>
              </div>
            }
          </div>
        </div>
      }
    </div>
  }
}
